import { PlanId } from 'domains/models/subscription/planId';
import TextField from 'presentations/views/components/atoms/TextField';

interface Props {
  isLoading?: boolean;
  label?: string;
  isDisabled?: boolean;
  placeholder?: string;
  value?: string | null;
  defaultValue?: string | null;
  isFullWidth?: boolean;
  isAutoFocus?: boolean;
  width?: number;
  height?: number;
  id?: string;
  name?: string;
  errors?: string[];
  helperText?: string;
  description?: string;
  rows?: number;
  maxRows?: number;
  isMultiline?: boolean;
  onChange?: any;
  onBlur?: any;
  isRequired?: boolean;
  isNotRequired?: boolean;
  isPaid?: boolean;
  isShowPaidLink?: boolean;
  plan?: PlanId;
  className?: string;
  variant?: 'outlined' | 'standard' | 'filled';
  outlineColor?: string;
}

export default function Component(props: Props) {
  return (
    <TextField
      isLoading={props.isLoading}
      id={props.id}
      name={props.name}
      description={props.description}
      isDisabled={props.isDisabled}
      rows={props.rows || 5}
      maxRows={props.maxRows}
      isMultiline={true}
      isPaid={props.isPaid}
      isShowPaidLink={props.isShowPaidLink}
      plan={props.plan}
      helperText={props.helperText}
      label={props.label}
      placeholder={props.placeholder}
      value={props.value}
      defaultValue={props.defaultValue}
      isFullWidth={props.isFullWidth}
      width={props.width}
      errors={props.errors}
      onChange={props.onChange}
      onBlur={props.onBlur}
      isRequired={props.isRequired}
      isNotRequired={props.isNotRequired}
      className={props.className}
      variant={props.variant}
      outlineColor={props.outlineColor}
      isAutoFocus={props.isAutoFocus}
    />
  );
}
